
const ProtectedRoute = ({isAuthenticated, element }) => {
    if (isAuthenticated) {
      return element;
    } else {

return null    }
  };

export default ProtectedRoute